import { useEffect, useState, type FC } from "react";
import { Eye, LogOut } from "lucide-react";

import { useImpersonation } from "@/shared/providers/ImpersonationProvider";
import { terminateImpersonation } from "@/shared/utils/impersonation";

export const ImpersonationBanner: FC = () => {
  const { impersonation } = useImpersonation();
  const isImpersonating = Boolean(impersonation);
  const [isTerminating, setIsTerminating] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (isImpersonating) {
      root.setAttribute("data-impersonating", "true");
    } else {
      root.removeAttribute("data-impersonating");
    }
    return () => {
      root.removeAttribute("data-impersonating");
    };
  }, [isImpersonating]);

  const handleEndSession = () => {
    setIsTerminating(true);
    void terminateImpersonation();
  };

  return isImpersonating && impersonation ? (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[200] flex h-[var(--impersonation-banner-height)] items-center justify-center gap-2 bg-inverse px-4 text-center text-white"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="text-sm text-white">
        Viewing as {impersonation.user_email} <span className="text-tertiary">—</span> admin session
      </p>
      <button
        type="button"
        onClick={handleEndSession}
        disabled={isTerminating}
        aria-label="End impersonation session"
        className="absolute right-4 flex items-center gap-1.5 rounded-md border border-white/40 px-2.5 py-1 text-sm text-white transition-colors hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <LogOut className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {isTerminating ? "Ending..." : "End session"}
      </button>
    </div>
  ) : null;
};
